<template>
  <div style="background:#fff; padding:20px;">
    <div style="margin-bottom:20px;">
      <a-select v-model="query.teamId" allow-clear placeholder="选择队伍" style="width:240px; margin-right:10px;">
        <a-select-option v-for="item in teamOptions" :key="item.id" :value="item.id">{{ item.teamName }}</a-select-option>
      </a-select>
      <a-select v-model="query.joinStatus" allow-clear placeholder="成员状态" style="width:160px; margin-right:10px;">
        <a-select-option :value="0">待审核</a-select-option>
        <a-select-option :value="1">已加入</a-select-option>
        <a-select-option :value="2">已拒绝</a-select-option>
      </a-select>
      <a-button type="primary" icon="search" @click="loadData">查询</a-button>
    </div>

    <a-table :columns="columns" :data-source="data" rowKey="id" :loading="loading" :pagination="pagination" @change="handleTableChange">
      <span slot="joinStatus" slot-scope="text">
        <a-tag :color="statusMap[text] && statusMap[text].color">{{ statusMap[text] ? statusMap[text].label : '未知' }}</a-tag>
      </span>
      <span slot="isLeader" slot-scope="text">
        <a-tag :color="text === 1 ? 'blue' : 'default'">{{ text === 1 ? '领队' : '成员' }}</a-tag>
      </span>
      <span slot="action" slot-scope="text, record">
        <a @click="openReview(record)">审核</a>
        <a-divider type="vertical" />
        <a-popconfirm title="确定删除吗？" @confirm="handleDelete(record.id)">
          <a style="color:red;">删除</a>
        </a-popconfirm>
      </span>
    </a-table>

    <a-modal v-model="visible" title="审核成员" @ok="submitReview">
      <a-form-model :model="reviewForm" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
        <a-form-model-item label="成员姓名">
          <a-input v-model="reviewForm.memberName" disabled />
        </a-form-model-item>
        <a-form-model-item label="审核结果">
          <a-radio-group v-model="reviewForm.approved">
            <a-radio :value="1">通过</a-radio>
            <a-radio :value="0">拒绝</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="审核备注">
          <a-textarea v-model="reviewForm.remark" :rows="3" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { deleteDragonMember, getDragonMemberList, getDragonTeamList, reviewDragonMember } from '@/api'

export default {
  data() {
    return {
      query: { teamId: undefined, joinStatus: undefined },
      teamOptions: [],
      data: [],
      loading: false,
      visible: false,
      reviewForm: {
        approved: 1
      },
      pagination: { current: 1, pageSize: 10, total: 0 },
      statusMap: {
        0: { label: '待审核', color: 'orange' },
        1: { label: '已加入', color: 'green' },
        2: { label: '已拒绝', color: 'red' }
      },
      columns: [
        { title: '所属队伍', dataIndex: 'teamName' },
        { title: '姓名', dataIndex: 'memberName' },
        { title: '手机号', dataIndex: 'mobile' },
        { title: '身份证号', dataIndex: 'idCardNo' },
        { title: '身份', dataIndex: 'isLeader', width: 100, scopedSlots: { customRender: 'isLeader' } },
        { title: '状态', dataIndex: 'joinStatus', width: 100, scopedSlots: { customRender: 'joinStatus' } },
        { title: '备注', dataIndex: 'reviewRemark' },
        { title: '操作', key: 'action', width: 160, scopedSlots: { customRender: 'action' } }
      ]
    }
  },
  created() {
    this.loadTeams()
    this.loadData()
  },
  methods: {
    loadTeams() {
      getDragonTeamList({ page: 1, pageSize: 200 }).then(res => {
        this.teamOptions = res.data.list || []
      })
    },
    loadData() {
      this.loading = true
      getDragonMemberList({
        page: this.pagination.current,
        pageSize: this.pagination.pageSize,
        teamId: this.query.teamId,
        joinStatus: this.query.joinStatus
      }).then(res => {
        this.data = res.data.list
        this.pagination.total = res.data.total
      }).finally(() => {
        this.loading = false
      })
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current
      this.loadData()
    },
    openReview(record) {
      this.reviewForm = {
        memberId: record.id,
        memberName: record.memberName,
        approved: record.joinStatus === 2 ? 0 : 1,
        remark: record.reviewRemark
      }
      this.visible = true
    },
    submitReview() {
      reviewDragonMember(this.reviewForm).then(() => {
        this.$message.success('审核完成')
        this.visible = false
        this.loadData()
      })
    },
    handleDelete(id) {
      deleteDragonMember({ memberId: id }).then(() => {
        this.$message.success('删除成功')
        this.loadData()
      })
    }
  }
}
</script>
